export const Header = {
    data () {},
    mounted () {},
    methods: {
        // 点击我的
        bindPersonalCenter () {
            if (this.loginTxt === this.$route.meta.title) return
            if (this.isLogin) {
            this.$router.push('/my/info')
            } else {
            this.$router.push('/login')
            }
            this.showNavContent = false
        },
        // 点击注册
        bindRegisterBtn () {
            if (this.$route.meta.title === '注册') return
            this.$router.push('/register')
        },
        // 点击退出
        bindLogoutBtn () {
            localStorage.removeItem('user_token');
            localStorage.removeItem('userinf');
            this.setIsLogin(false)
            this.setIsBiger(false)
            if (this.$route.meta.title !== '首页') {
                this.$router.replace('/index')
            }
        },
        //点击切换大字版和普通版
        bindBigerBtn () {
            const tempusbiger = localStorage.getItem('isBiger');
            //console.log("获取值：")
            //console.log(tempusbiger)
            //console.log("获取值2：")
            //console.log(this.isBiger)
            //if(this.isBiger){
            if(tempusbiger == 'true'){
                //切换正常版
                console.log("切换正常版")
                localStorage.setItem('isBiger', false);
                this.setIsBiger(false)
                //location.reload(); // 刷新当前页面
            }else{
                //切换大字版
                console.log("切换大字版")
                localStorage.setItem('isBiger', true);
                this.setIsBiger(true)
                //this.$router.go(0); // 刷新当前页面
                //location.reload();
            }
            //if (this.$route.meta.title !== '首页') {
            //    this.$router.replace('/index')
            //}
        },
    }
}